import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Icon } from 'blaze-ui/icons/Types'
import {
  Facebook,
  Google,
  GoogleDrive,
  Instagram,
  LinkedIn,
  Shopify,
  TikTokBrand,
  Twitter,
  Wix,
  YouTube,
} from 'blaze-ui/icons'
import WordPressLogo from 'almanac-ui/icons/24/WordPressLogo'
import { FacebookBrand, MailchimpBrand, InstagramBrand, LinkedInBrand, TwitterBrand } from 'blaze-ui/icons/35'
import MetaBrand from 'blaze-ui/icons/20/MetaBrand'
import { GoHighLevelBrand } from 'blaze-ui/icons/35/GoHighLevelBrand'

export const PlatformIcons: Record<ExternalIntegrationEnum, Icon> = {
  [ExternalIntegrationEnum.Facebook]: FacebookBrand,
  [ExternalIntegrationEnum.Instagram]: InstagramBrand,
  [ExternalIntegrationEnum.LinkedIn]: LinkedInBrand,
  [ExternalIntegrationEnum.X]: TwitterBrand,
  [ExternalIntegrationEnum.WordPress]: WordPressLogo,
  [ExternalIntegrationEnum.Google]: Google,
  [ExternalIntegrationEnum.GoogleDrive]: GoogleDrive,
  [ExternalIntegrationEnum.GoogleBusinessProfile]: Google,
  [ExternalIntegrationEnum.Mailchimp]: MailchimpBrand,
  [ExternalIntegrationEnum.TikTok]: TikTokBrand,
  [ExternalIntegrationEnum.YouTube]: YouTube,
  [ExternalIntegrationEnum.MetaAds]: MetaBrand,
  [ExternalIntegrationEnum.GoHighLevel]: GoHighLevelBrand,
  [ExternalIntegrationEnum.Wix]: Wix,
  [ExternalIntegrationEnum.Shopify]: Shopify,
}

export const ProviderIcons: Record<ExternalIntegrationEnum, Icon> = {
  [ExternalIntegrationEnum.Facebook]: Facebook,
  [ExternalIntegrationEnum.Instagram]: Instagram,
  [ExternalIntegrationEnum.LinkedIn]: LinkedIn,
  [ExternalIntegrationEnum.X]: Twitter,
  [ExternalIntegrationEnum.WordPress]: WordPressLogo,
  [ExternalIntegrationEnum.Google]: Google,
  [ExternalIntegrationEnum.GoogleDrive]: GoogleDrive,
  [ExternalIntegrationEnum.GoogleBusinessProfile]: Google,
  [ExternalIntegrationEnum.Mailchimp]: MailchimpBrand,
  [ExternalIntegrationEnum.TikTok]: TikTokBrand,
  [ExternalIntegrationEnum.YouTube]: YouTube,
  [ExternalIntegrationEnum.MetaAds]: MetaBrand,
  [ExternalIntegrationEnum.GoHighLevel]: GoHighLevelBrand,
  [ExternalIntegrationEnum.Wix]: Wix,
  [ExternalIntegrationEnum.Shopify]: Shopify,
}

export const ProviderToName: Record<ExternalIntegrationEnum, string> = {
  [ExternalIntegrationEnum.Facebook]: 'Facebook',
  [ExternalIntegrationEnum.Instagram]: 'Instagram',
  [ExternalIntegrationEnum.LinkedIn]: 'LinkedIn',
  [ExternalIntegrationEnum.X]: 'X',
  [ExternalIntegrationEnum.WordPress]: 'Wordpress',
  [ExternalIntegrationEnum.Google]: 'Google',
  [ExternalIntegrationEnum.GoogleDrive]: 'Google Drive',
  [ExternalIntegrationEnum.GoogleBusinessProfile]: 'Google Business Profile',
  [ExternalIntegrationEnum.TikTok]: 'TikTok',
  [ExternalIntegrationEnum.YouTube]: 'Youtube',
  [ExternalIntegrationEnum.Mailchimp]: 'Mailchimp',
  [ExternalIntegrationEnum.MetaAds]: 'Meta Ads',
  [ExternalIntegrationEnum.GoHighLevel]: 'GoHighLevel',
  [ExternalIntegrationEnum.Wix]: 'Wix',
  [ExternalIntegrationEnum.Shopify]: 'Shopify',
}
